var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar-menu fixed mw-100 bg-cl-secondary" },
    [
      _c("div", { staticClass: "row brdr-bottom-1 brdr-cl-bg-secondary" }, [
        _vm.submenu.depth
          ? _c(
              "div",
              { staticClass: "col-xs bg-cl-primary" },
              [
                _c("sub-btn", {
                  staticClass: "bg-cl-transparent brdr-none",
                  attrs: { type: "back" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs bg-cl-primary" }, [
          _c(
            "button",
            {
              staticClass:
                "w-100 inline-flex end-xs bg-cl-transparent brdr-none p0 close-btn",
              attrs: { type: "button", "aria-label": _vm.$t("Close") },
              on: { click: _vm.closeMenu }
            },
            [_c("i", { staticClass: "material-icons p15" }, [_vm._v("close")])]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { ref: "container", staticClass: "sidebar-menu__container row" },
        [
          _c("div", { staticClass: "col-xs-12 h4 serif" }, [
            _c(
              "ul",
              {
                staticClass: "p0 m0 relative sidebar-menu__list",
                style: _vm.mainListStyles
              },
              [
                _c(
                  "li",
                  {
                    staticClass:
                      "brdr-bottom-1 brdr-cl-bg-secondary bg-cl-primary",
                    on: { click: _vm.closeMenu }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "block px25 py20 cl-accent no-underline",
                        attrs: { to: _vm.localizedRoute("/"), exact: "" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("Home")) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.visibleCategories(), function(category) {
                  return _c(
                    "li",
                    {
                      key: category.slug,
                      staticClass:
                        "brdr-bottom-1 brdr-cl-bg-secondary bg-cl-primary flex",
                      on: { click: _vm.closeMenu }
                    },
                    [
                      _vm.isCurrentMenuShowed
                        ? _c(
                            "div",
                            { staticClass: "subcategory-item" },
                            [
                              category.children_count > 0
                                ? _c("sub-btn", {
                                    staticClass:
                                      "bg-cl-transparent brdr-none fs-medium",
                                    attrs: {
                                      id: category.id,
                                      name: category.name
                                    }
                                  })
                                : _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "px25 py20 cl-accent no-underline col-xs",
                                      attrs: { to: _vm.categoryLink(category) }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(category.name) +
                                          "\n            "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("sub-category", {
                        attrs: {
                          "category-links": category.children_data,
                          id: category.id,
                          "parent-slug": category.slug,
                          "parent-path": category.url_path
                        }
                      })
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.getCmsData, function(menuItem, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "bg-cl-secondary",
                      on: { click: _vm.closeMenu }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "block px25 py20 brdr-bottom-1 brdr-cl-secondary cl-accent no-underline fs-medium",
                          attrs: {
                            href: _vm.getUrl(menuItem),
                            target: _vm.getTarget(menuItem),
                            exact: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(menuItem.displayName) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.compareIsActive && _vm.isCurrentMenuShowed
                  ? _c(
                      "li",
                      {
                        staticClass: "bg-cl-secondary",
                        on: { click: _vm.closeMenu }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "block px25 py20 brdr-bottom-1 brdr-cl-secondary cl-accent no-underline fs-medium-small",
                            attrs: {
                              to: _vm.localizedRoute("/compare"),
                              exact: ""
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("Compare products")) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass:
                      "brdr-bottom-1 brdr-cl-secondary bg-cl-secondary flex",
                    on: { click: _vm.login }
                  },
                  [
                    _vm.currentUser
                      ? _c("sub-btn", {
                          staticClass:
                            "bg-cl-transparent brdr-none fs-medium-small",
                          attrs: {
                            id: "my-account-links",
                            "is-category": false,
                            name: _vm.$t("My account")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentUser
                      ? _c("sub-category", {
                          attrs: {
                            "my-account-links": _vm.myAccountLinks,
                            id: "my-account-links"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.closeMenu($event)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.currentUser && _vm.isCurrentMenuShowed
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "block w-100 px25 py20 cl-accent no-underline fs-medium-small",
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.closeMenu($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("My account")) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              2
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }